import { rem } from 'polished';

export default {
  sm: 0, // mobile
  md: rem(768), // tablet portrait
  lg: rem(1024), // tablet landscape
  xlg: rem(1200), // desktop
};
